<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="企微客户" v-if="findChildren(184)!==-1" name="crmcustomerwecom" style="height: 100%;">
				<crmcustomerwecom-index />
			</el-tab-pane>
			<el-tab-pane label="客户列表" v-if="findChildren(51)!==-1" name="crmcustomer" style="height: 100%;">
				<crmcustomer-index />
			</el-tab-pane>
			<el-tab-pane label="客户档案袋" v-if="findChildren(179)!==-1" name="crmcustomerarchive" style="height: 100%;">
				<crmcustomerarchive-index />
			</el-tab-pane>
<!-- 			<el-tab-pane label="待跟踪客户" v-if="findChildren(71)!==-1" name="crmcustomertrack" style="height: 100%;">
				<crmcustomertrack-index />
			</el-tab-pane>
			<el-tab-pane label="公海客户" v-if="findChildren(72)!==-1" name="crmcustomersea" style="height: 100%;">
				<crmcustomersea-index />
			</el-tab-pane> -->
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import crmcustomerwecomIndex from './crmcustomerwecom/index.vue'
	import crmcustomerIndex from './crmcustomer/index.vue'
	import crmcustomerarchiveIndex from './crmcustomerarchive/index.vue'
	// import crmcustomertrackIndex from './crmcustomertrack/index.vue'
	// import crmcustomerseaIndex from './crmcustomersea/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if(this.departmentChildren.length!=0){
				this.activeName = this.departmentChildren[0].controller
			}
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			crmcustomerwecomIndex,
			crmcustomerIndex,
			crmcustomerarchiveIndex
			// crmcustomertrackIndex,
			// crmcustomerseaIndex

		}
	}
</script>
